import { Outlet } from 'react-router';

import { useDocumentTitle } from '../use-document-title';

/**
 * Outermost route. Owns the one concern that spans every screen — the document
 * title — and renders whatever matched below it.
 *
 * It lives here rather than inline in `router.tsx` so that file stays a pure
 * route table with no components in it, which is what keeps Fast Refresh
 * working across edits to the routes.
 */
export function RootLayout() {
    useDocumentTitle();

    return <Outlet />;
}
